import script from "./powerStationVideoScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./powerStationVideoScreen.vue?vue&type=script&setup=true&lang=js"

import "./powerStationVideoScreen.vue?vue&type=style&index=0&id=76c2c26e&lang=less"

const __exports__ = script;

export default __exports__